export default "/_next/static/images/887a806ef07e68a24e68a7a4a3067b19.jpg";